import { forwardRef, InputHTMLAttributes, ReactNode } from 'react'

import { cn } from '@/app/utils'
import CheckIconSvg from '@/assets/svg/CheckIcon.svg'

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: ReactNode
  isValid?: boolean
  className?: string
  checkIconColor?: string
  dataTestId?: string
}

const AppCheckbox = forwardRef<HTMLInputElement, Props>(
  (
    {
      className,
      checked,
      label,
      checkIconColor,
      isValid = true,
      dataTestId,
      ...props
    },
    ref
  ) => {
    return (
      <label
        htmlFor={props.id}
        data-testid={dataTestId}
        className="flex items-center gap-8"
      >
        <input
          ref={ref}
          type="checkbox"
          className="peer hidden"
          checked={checked}
          {...props}
        />
        <span
          className={cn(
            'flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-4 border border-grey-30 bg-white transition-all peer-enabled:cursor-pointer',
            'peer peer-checked:border-bronze-40 peer-checked:bg-bronze-40 peer-disabled:opacity-50',
            '[&>svg]:mt-1 [&>svg]:opacity-0 [&>svg]:transition-all peer-checked:[&>svg]:opacity-100',
            !isValid && 'border-red-50',
            className
          )}
        >
          <CheckIconSvg className={checkIconColor || 'text-white'} />
        </span>
        {label && <span className="font-pro text-16">{label}</span>}
      </label>
    )
  }
)

AppCheckbox.displayName = 'AppCheckbox'
export default AppCheckbox
